import "./_inputFile.scss";

import cx from "classnames";
import {ReactElement, useState} from "react";
import {useDropzone} from "react-dropzone";
import {Control, Controller} from "react-hook-form";

import iconTrash from "@/assets/massification/iconTrash.svg";

import Button from "../Button/Button";

export function InputFile({
  control,
  name,
  label,
  isRequire,
  handleDeleteFile = () => {
    return;
  },
}: {
  control: Control<any, any, any>;
  name: string;
  label: string;
  isRequire?: string | boolean;
  handleDeleteFile: () => void;
}): ReactElement {
  const [dragReject, setDragReject] = useState(false);

  const handleDragEnter = (e: React.DragEvent<HTMLDivElement>): void => {
    e.preventDefault();
    const items = Array.from(e.dataTransfer.items);
    const allValid = items.every(
      item => item.kind === "file" && item.type.startsWith("image/"),
    );
    setDragReject(!allValid);
  };

  const handleDragLeave = (e: React.DragEvent<HTMLDivElement>): void => {
    e.preventDefault();
    setDragReject(false);
  };
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={[]}
      rules={{required: isRequire}}
      render={({field: {onChange, value, ref}}) => {
        const {getRootProps, getInputProps, isDragActive} = useDropzone({
          accept: {
            ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel":
              [],
          },
          maxFiles: 1,
          multiple: false,
          onDrop: acceptedFiles => {
            onChange([...acceptedFiles]);
            setDragReject(false);
          },
          onDragEnter: event => {
            const items = event?.dataTransfer?.items;
            if (!items) return;
            const valid = Array.from(items).every(
              item => item.kind === "file" && item.type,
            );
            setDragReject(!valid || Array.from(items).length > 1);
          },
          onDragLeave: () => {
            setDragReject(false);
          },
        });
        const handleRemoveFile = (indexToRemove: number): void => {
          handleDeleteFile();
          const newFiles = value.filter(
            (_: any, index: number) => index !== indexToRemove,
          );
          onChange(newFiles);
        };
        return (
          <div
            onDragEnter={handleDragEnter}
            onDragLeave={handleDragLeave}
            {...getRootProps()}
            className={cx(
              "inputFile",

              isDragActive ? "inputFile-dropzone--active" : "",
              dragReject ? "inputFile-dropzone--error" : "",
            )}
            ref={ref}>
            <label>{label}</label>
            {isDragActive ? (
              <div className="inputFile-upload">
                <label>Import du fichier</label>
              </div>
            ) : (
              <>
                {value.length > 0 ? (
                  <ul>
                    {value.map(
                      (file: {name?: string; nom?: string}, index: number) => {
                        return (
                          <li key={index} className="inputFile-element">
                            {file?.nom || file?.name}
                            <Button
                              label={""}
                              variant={"secondary icon"}
                              icon={iconTrash}
                              onClick={() => {
                                handleDeleteFile();
                                handleRemoveFile(index);
                              }}
                            />
                          </li>
                        );
                      },
                    )}
                  </ul>
                ) : (
                  <div className="inputFile-wait_upload">
                    <input {...getInputProps()} />
                    <Button
                      label={"Charger un fichier"}
                      variant={"secondary"}
                      onClick={e => e.preventDefault()}
                    />
                  </div>
                )}
              </>
            )}
          </div>
        );
      }}
    />
  );
}
